import React from 'react';
import { PropTypes } from 'prop-types';
import { Trans, useTranslation } from 'react-i18next';
import { useFeasibility } from 'hooks/useFeasibility';
import { REASONS } from 'utils/feasibility/constants';

const NonFeasibleMessage = ({ className }) => {
  const { t } = useTranslation('Summary');
  const { waitingTime, reason } = useFeasibility();
  const isLHExpress = reason === REASONS.LH_EXPRESS;

  return (
    <div className={className} data-testid="non-feasible-message">
      {isLHExpress && <p>{t('lh_express_message')}</p>}
      {!isLHExpress && (
        <p>
          <Trans
            t={t}
            i18nKey="non_feasible_message"
            values={{ waitingTime }}
            components={[<b />]}
          />
        </p>
      )}
    </div>
  );
};

NonFeasibleMessage.propTypes = {
  className: PropTypes.string,
};

export default NonFeasibleMessage;
